import { type FeatureModule } from '@store/features/types';

import templateUndoReducer from './templateUndoSlice';

export const notesFeature: FeatureModule = {
  id: 'notes',
  name: 'Notes',
  dependencies: [],
  reducers: {
    templateUndo: templateUndoReducer,
  },
  middleware: [],
  persistence: { enabled: false },
  sync: { enabled: false },
  setup: _store => {},
  cleanup: _store => {},
};
